import * as React from 'react';
import { connect } from 'react-redux';

import { FromToControl } from '../../../../common/components/from_to_control';
import { IAppState, Dispatch } from '../../../../common/state';
import { IJsonQueryRange } from '../../../../json_query';
import { changeMaxArea, changeMinArea } from '../../../state/advanced/area';
import { InlineParam, Row } from '../markup';

const style = require('../index.css');

export interface IHouseAreaProps {
  totalArea?: IJsonQueryRange;
  onMinAreaChanged(value: number | undefined): void;
  onMaxAreaChanged(value: number | undefined): void;
}

export const area: React.StatelessComponent<IHouseAreaProps> = props => (
  <Row title="Площадь дома">
    <InlineParam>
      <FromToControl
        rangeGroupStyle={style['fromToControl']}
        from={{
          value: props.totalArea && props.totalArea.value.gte,
          placeholder: 'от',
          onValueChange: value => props.onMinAreaChanged(value),
        }}
        to={{
          value: props.totalArea && props.totalArea.value.lte,
          placeholder: 'до',
          onValueChange: value => props.onMaxAreaChanged(value),
        }}
      />
    </InlineParam>
    {'м\u00B2'}
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    totalArea: state.filters.jsonQuery.total_area,
  }),
  (dispatch: Dispatch) => ({
    onMinAreaChanged: (value: number | undefined) => {
      dispatch(changeMinArea('total_area', value));
    },
    onMaxAreaChanged: (value: number | undefined) => {
      dispatch(changeMaxArea('total_area', value));
    },
  }),
)(area);
